import {CerbaAuthService} from "@digicerba/common";
import {Observable} from "rxjs/Observable";
import {Injectable} from "@angular/core";
import {ConnectionBackend, Headers, Http, Request, RequestOptions, RequestOptionsArgs, Response} from "@angular/http";

@Injectable()
export class HttpOverride extends Http {

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions, private cerbaAuthService: CerbaAuthService) {
        super(backend, defaultOptions);
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return super.request(url, options);
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        let response = super.get(url, this.getRequestOptionArgs(options)).share();
        response.subscribe(_response => {
                this.addClickJackingHeaderSecurity(_response);
            },
            error => {
            if (error.url && error.url.endsWith('/me')) {
                if (error.status === 401) {
                    // L'utilisateur n'a pas accès à la ressources
                    window.location.href = '401.html';
                }
                if (error.status === 500) {
                    window.location.href = '500.html';
                }
                console.log('response:', response);
            } else {
                console.log('error', error);
            }
            if (error.status === 410) {
                // L'utilisateur a des informations d'authentification obsolètes
                window.location.reload(true);
            }
        });
        return response;
    }

    post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        //Sert à la gestion du ContentType pour l'upload du fichier
        const addContentType = !(body && body.get && body.get('file') && body.get('file').size);
        let response = super.post(url, body, this.getRequestOptionArgs(options, addContentType)).share();
        response.subscribe(_response => {
                this.addClickJackingHeaderSecurity(_response);

            },
            error => {
            if (error.status === 410) {
                // L'utilisateur a des informations d'authentification obsolètes
                window.location.reload(true);
            }
        });
        return response;
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        let response = super.put(url, body, this.getRequestOptionArgs(options)).share();
        response.subscribe(_response => {
                this.addClickJackingHeaderSecurity(_response);

            },
            error => {
            if (error.status === 410) {
                // L'utilisateur a des informations d'authentification obsolètes
                window.location.reload(true);
            }
        });
        return response;
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        let response = super.delete(url, this.getRequestOptionArgs(options)).share();
        response.subscribe(_response => {
                this.addClickJackingHeaderSecurity(_response);

            },
            error => {
            if (error.status === 410) {
                // L'utilisateur a des informations d'authentification obsolètes
                window.location.reload(true);
            }
        });
        return response;
    }

    private getRequestOptionArgs(options?: RequestOptionsArgs, addContentType = true): RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }

        if (addContentType) {
            options.headers.append('Content-Type', 'application/json');
        }

        if (this.cerbaAuthService.getTokenAuthenticationHeader()) {
            options.headers.append('X-token-auth', this.cerbaAuthService.getTokenAuthenticationHeader());
        }
        if (this.cerbaAuthService.getTokenCorrespondantHeader()) {
            options.headers.append('X-token-correspondant', this.cerbaAuthService.getTokenCorrespondantHeader());
        }

        return options;
    }

    addClickJackingHeaderSecurity(response : Response){
        response.headers.append('Content-Security-Policy', "frame-ancestors 'self' *.mycerba.com;");
    }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/resources/httpOverride.ts